<template>
    <v-row class="main-row-fill-height">
        <!-- <v-col cols="3" class="py-0">
            <v-card max-height="100%" height="100%" color="grey lighten-3" style="overflow: auto;">
                <v-navigation-drawer width="100%" height="100%" style="padding-top: 70px;">
                    <v-toolbar absolute flat color="primary" width="100%" height="70px" dark>
                        <v-toolbar-title>Variantenauswahl</v-toolbar-title>
                    </v-toolbar>
                    <v-list class="pt-0">
                        <v-list-item-group v-model="currentActiveMenu" color="grey darken-4">
                            <v-list-item 
                                :style="currentActiveMenu === index ? 'pointer-events: none' : ''"
                                v-for="(item, index) in getNavigationItems"
                                :key="index"
                            >
                                <v-list-item-content>
                                    <v-list-item-title class="d-flex align-center justify-space-between">
                                        {{ index + 1 }}. {{ item.displayText }}
                                        <v-icon v-if="item.success" color="success" class="ml-4">mdi-check-circle</v-icon>
                                        <v-icon v-if="item.warning" color="error" class="ml-4">mdi-alert-circle-outline</v-icon>
                                        <v-icon v-if="item.required" class="ml-4">mdi-alert-circle</v-icon>
                                    </v-list-item-title>  
                                </v-list-item-content>
                            </v-list-item>
                        </v-list-item-group>
                    </v-list>
                </v-navigation-drawer>
            </v-card>
        </v-col> -->
        <v-col cols="9" class="pa-0 pos-rel pad-b">
            <div class="top-bar pl-14 pr-10 py-8" ref="topBar">
                <div class="content">
                    <div class="text-section">
                        <h2 class="mb-2 menu-title">{{ $t('variantenauswahl') }} </h2>
                        <p class="ma-0 menu-description">{{$t('variantenAuswahlDescription')}}</p>
                    </div>
                    <a href="javascript:void(0)" @click="toggleResources = !toggleResources" class="resources-holder" v-if="showResources">
                        <div class="resources" :class="{ 'active': toggleResources }">
                            <div class="resources-placeholders">
                                <p class="menu-description">{{ $t('resourcesLabel') }}</p>
                                <p class="font-weight-bold menu-title"><span>1</span> {{ $t('documentsLabel') }}, <span>0</span> {{ $t('imagesLabel') }}</p>
                            </div>
                            <div class="pl-5 dropdown-icon">
                                <v-icon class="icon-class">mdi-menu-down</v-icon>
                            </div>
                        </div>
                        <transition name="slide-fade">
                            <div class="resources-dropdown" v-if="toggleResources">
                                <div class="resources-placeholders">
                                    <p class="menu-description">{{ $t('resourcesLabel') }}</p>
                                    <p class="font-weight-bold menu-title"><span>1</span> {{ $t('documentsLabel') }}, <span>0</span> {{ $t('imagesLabel') }}</p>
                                </div>
                                <div class="resources-content">
                                    <div v-if="(typeof artikelnrDocument !== 'undefined' && Object.keys(artikelnrDocument).length > 0)"
                                        class="d-flex pa-3 mb-4 document-container ">
                                        <v-icon class="mr-2">mdi-file-document-multiple-outline</v-icon>
                                        <a class="black--text" target="_blank"
                                            :href="artikelnrDocument.resourceLocation" download>{{artikelnrDocument.title}}</a>
                                    </div>
                                </div>
                            </div>
                        </transition>
                    </a>
                </div>
            </div>

            <v-divider></v-divider>

            <v-card flat :style="{'height': `calc(100% - ${bodyCalcHeight}px)`, 'max-height' : '100%'}" data-simplebar class="pa-8 pl-12 pt-6">
                <simplebar style="overflow-x: hidden;" class="px-2">
                    
                    <template v-for="(item, index) in getNavigationItems">
                        <template
                            v-if="getSubNavActiveId.mainNavActiveId == 0 && getSubNavActiveId.subNavActiveId == index">
                            <template v-if="Array.isArray(item.name)">
                                <radio-container-double :key="index" :firstCharacteristic="getCharacteristic(item.name[0])"
                                    :second-characteristic="getCharacteristic(item.name[1])" :context="modelSelectionContext" />
                            </template>
                            <template v-else>
                                <radio-container :key="index" :characteristic="getCharacteristic(item.name)" :context="modelSelectionContext" />
                            </template>
                        </template>
                    </template>
                </simplebar>
            </v-card>
            <div class="bottom-bar pb-6 text-center">
                <v-divider class="py-4"></v-divider>
                <v-btn :disabled="nextSaveBtnDisabled" depressed color="green" dark @click="nextStep();">{{ $t('nextStepLabel') }}</v-btn>
            </div>
        </v-col>
        <v-col cols="3" class="py-0">
            <v-card max-height="100%" height="100%" color="grey lighten-3" style="overflow: auto;">
                <v-navigation-drawer width="100%" height="100%" style="padding-top: 70px;" permanent>
                    <div class="d-flex flex-column justify-space-between" style="height: 100%;">
                        <ModelsFound />
                        <div class="pr-1">
                            <v-expansion-panels flat accordion>
                                <RModelSelection />
                            </v-expansion-panels>
                        </div>
                        <div class="d-flex flex-column pa-4 right-buttons-holder">
                            <v-row class="px-2">
                                <v-col cols="6" class="px-2" v-if="newConfiguration">
                                    <v-btn outlined color="primary" width="100%" depressed @click="$EventBus.$emit('cancelDialogConfirmation')">
                                        {{ $t('cancelConfiguration') }}
                                    </v-btn>
                                </v-col>
                                <v-col class="px-2" :class="!newConfiguration? 'col-12' : 'col-6'">
                                    <SaveCurrentConfiguration :disabled-save-btn="nextSaveBtnDisabled" />
                                </v-col>
                            </v-row>
                        </div>
                    </div>
                </v-navigation-drawer>
            </v-card>
        </v-col>
    </v-row>
    <!-- <div class="content-wrapper" id="model-selection">
        <div class="wrapper-mask show" v-if="showModal"></div>
        <div class="row no-gutters content-row" v-if="!showModal">
            <div class="col-3">
                <div class="column-wrap d-flex flex-column">
                    <h3 class="title nav-title">Variantenauswahl</h3>
                    <div class="inner-wrap d-flex" data-simplebar>
                        <div class="nav flex-column nav-pills main-navigation text-left" id="v-pills-tab" role="tablist" aria-orientation="vertical">
                        <a class="nav-link" v-bind:class="{ active: active == 1, 'success' : getNavigationItem('KTU_MM_HAUPTFUNKTION').success, 'warning' : getNavigationItem('KTU_MM_HAUPTFUNKTION').warning, 'required' : getNavigationItem('KTU_MM_HAUPTFUNKTION').required }" @click.prevent="settingsNavigation(1)">1. Hauptfunktion</a>   
                        <a class="nav-link" v-bind:class="{ active: active == 2, 'success' : getNavigationItem('KTU_MM_ANWENDUNG').success, 'warning' : getNavigationItem('KTU_MM_ANWENDUNG').warning, 'required' : getNavigationItem('KTU_MM_ANWENDUNG').required }" @click.prevent="settingsNavigation(2)">2. Anwendung</a>
                        <a class="nav-link" v-bind:class="{ active: active == 3, 'success' : getNavigationItem('KTU_MM_WERKSTOFF').success, 'warning' : getNavigationItem('KTU_MM_WERKSTOFF').warning, 'required' : getNavigationItem('KTU_MM_WERKSTOFF').required }" @click.prevent="settingsNavigation(3)">3. Werkstoff Tür</a>
                        <a class="nav-link" v-bind:class="{ active: active == 4, 'success' : getNavigationItem('KTU_MM_ZARGEN_WERKSTOFF').success, 'warning' : getNavigationItem('KTU_MM_ZARGEN_WERKSTOFF').warning, 'required' : getNavigationItem('KTU_MM_ZARGEN_WERKSTOFF').required }" @click.prevent="settingsNavigation(4)">4. Werkstoff Zarge</a>
                        <a class="nav-link" v-bind:class="{ active: active == 5, 'success' : getNavigationItem('KTU_MM_OEFFNUNGSART').success && getNavigationItem('KTU_MM_KOMBI_ST_OL').success, 'warning' : getNavigationItem('KTU_MM_OEFFNUNGSART').warning || getNavigationItem('KTU_MM_KOMBI_ST_OL').warning, 'required' : getNavigationItem('KTU_MM_OEFFNUNGSART').required || getNavigationItem('KTU_MM_KOMBI_ST_OL').required }" @click.prevent="settingsNavigation(5)">5. Bauform</a>
                        <a class="nav-link" v-bind:class="{ active: active == 6, 'success' : getNavigationItem('KTU_MM_FUNKTION_RC').success, 'warning' : getNavigationItem('KTU_MM_FUNKTION_RC').warning, 'required' : getNavigationItem('KTU_MM_FUNKTION_RC').required }" @click.prevent="settingsNavigation(6)">6. Einbruchschutz</a>
                        <a class="nav-link" v-bind:class="{ active: active == 7, 'success' : getNavigationItem('KTU_MM_FUNKTION_BH').success, 'warning' : getNavigationItem('KTU_MM_FUNKTION_BH').warning, 'required' : getNavigationItem('KTU_MM_FUNKTION_BH').required }" @click.prevent="settingsNavigation(7)">7. Brandschutz</a>
                        <a class="nav-link" v-bind:class="{ active: active == 8, 'success' : getNavigationItem('KTU_MM_FUNKTION_RH').success, 'warning' : getNavigationItem('KTU_MM_FUNKTION_RH').warning, 'required' : getNavigationItem('KTU_MM_FUNKTION_RH').required }" @click.prevent="settingsNavigation(8)">8. Rauchschutz</a>
                        <a class="nav-link" v-bind:class="{ active: active == 9, 'success' : getNavigationItem('KTU_MM_FUNKTION_WS').success, 'warning' : getNavigationItem('KTU_MM_FUNKTION_WS').warning, 'required' : getNavigationItem('KTU_MM_FUNKTION_WS').required }" @click.prevent="settingsNavigation(9)">9. Wärmeschutz</a>
                        <a class="nav-link" v-bind:class="{ active: active == 10, 'success' : getNavigationItem('KTU_MM_FUNKTION_S').success, 'warning' : getNavigationItem('KTU_MM_FUNKTION_S').warning, 'required' : getNavigationItem('KTU_MM_FUNKTION_S').required }" @click.prevent="settingsNavigation(10)">10. Schallschutz</a>
                        <a class="nav-link" v-bind:class="{ active: active == 11, 'success' : getNavigationItem('KTU_MM_FUNKTION_KK').success, 'warning' : getNavigationItem('KTU_MM_FUNKTION_KK').warning, 'required' : getNavigationItem('KTU_MM_FUNKTION_KK').required }" @click.prevent="settingsNavigation(11)">11. Klimaklasse</a>
                        <a class="nav-link" v-bind:class="{ active: active == 12, 'success' : getNavigationItem('KTU_MM_TUERBLATT_DICKE').success, 'warning' : getNavigationItem('KTU_MM_TUERBLATT_DICKE').warning, 'required' : getNavigationItem('KTU_MM_TUERBLATT_DICKE').required }" @click.prevent="settingsNavigation(12)">12. Türblattdicke</a>
                        <a class="nav-link" v-bind:class="{ active: active == 13, 'success' : getNavigationItem('KTU_MM_FUNKTION_VSOE').success, 'warning' : getNavigationItem('KTU_MM_FUNKTION_VSOE').warning, 'required' : getNavigationItem('KTU_MM_FUNKTION_VSOE').required }" @click.prevent="settingsNavigation(13)">13. Hochsicherheitstür</a>
                        <a class="nav-link" v-bind:class="{ active: active == 14, 'success' : getNavigationItem('KTU_MM_PANIK').success, 'warning' : getNavigationItem('KTU_MM_PANIK').warning, 'required' : getNavigationItem('KTU_MM_PANIK').required }" @click.prevent="settingsNavigation(14)">14. Paniktür EN1125</a>
                        <a class="nav-link" v-bind:class="{ active: active == 15, 'success' : getNavigationItem('KTU_MM_FLUCHT').success, 'warning' : getNavigationItem('KTU_MM_FLUCHT').warning, 'required' : getNavigationItem('KTU_MM_FLUCHT').required }" @click.prevent="settingsNavigation(15)">15. Fluchttür EN179</a>
                        <a class="nav-link" v-bind:class="{ active: active == 16, 'success' : getNavigationItem('CUST_MM_MODELLREIHE').success, 'warning' : getNavigationItem('CUST_MM_MODELLREIHE').warning, 'required' : getNavigationItem('CUST_MM_MODELLREIHE').required }" @click.prevent="settingsNavigation(16)">16. Modellreihe</a>
                        <a class="nav-link" v-bind:class="{ active: active == 17, 'success' : getNavigationItem('KTU_MM_MODELL').success, 'warning' : getNavigationItem('KTU_MM_MODELL').warning, 'required' : getNavigationItem('KTU_MM_MODELL').required }" @click.prevent="settingsNavigation(17)">17. Modelle</a>
                        <a class="nav-link" v-bind:class="{ active: active == 18, 'success' : getNavigationItem('KTU_MM_ARTIKELNR').success, 'warning' : getNavigationItem('KTU_MM_ARTIKELNR').warning, 'required' : getNavigationItem('KTU_MM_ARTIKELNR').required }" @click.prevent="settingsNavigation(18)">18. Artikelnummer</a>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-6 purple-background-after">
                <div class="column-wrap middle-col d-flex flex-column">
                    <div class="inner-wrap d-flex" data-simplebar id="innerWrapper">
                        <div class="scroll-wrap">
                            <radio-container :characteristic="getCharacteristic('KTU_MM_HAUPTFUNKTION')" :settingsVal="showSettingsContent" :settingsContent="1"  />
                            <radio-container :characteristic="getCharacteristic('KTU_MM_ANWENDUNG')" :settingsVal="showSettingsContent" :settingsContent="2"  />
                            <radio-container :characteristic="getCharacteristic('KTU_MM_WERKSTOFF')" :settingsVal="showSettingsContent" :settingsContent="3"  />
                            <radio-container :characteristic="getCharacteristic('KTU_MM_ZARGEN_WERKSTOFF')" :settingsVal="showSettingsContent" :settingsContent="4"  />
                            <radio-container-double :firstCharacteristic="getCharacteristic('KTU_MM_OEFFNUNGSART')" :second-characteristic="getCharacteristic('KTU_MM_KOMBI_ST_OL')" :settingsVal="showSettingsContent" :settingsContent="5"  />
                            <radio-container :characteristic="getCharacteristic('KTU_MM_FUNKTION_RC')" :settingsVal="showSettingsContent" :settingsContent="6"  />
                            <radio-container :characteristic="getCharacteristic('KTU_MM_FUNKTION_BH')" :settingsVal="showSettingsContent" :settingsContent="7"  />
                            <radio-container :characteristic="getCharacteristic('KTU_MM_FUNKTION_RH')" :settingsVal="showSettingsContent" :settingsContent="8"  />
                            <radio-container :characteristic="getCharacteristic('KTU_MM_FUNKTION_WS')" :settingsVal="showSettingsContent" :settingsContent="9"  />
                            <radio-container :characteristic="getCharacteristic('KTU_MM_FUNKTION_S')" :settingsVal="showSettingsContent" :settingsContent="10"  />
                            <radio-container :characteristic="getCharacteristic('KTU_MM_FUNKTION_KK')" :settingsVal="showSettingsContent" :settingsContent="11"  />
                            <radio-container :characteristic="getCharacteristic('KTU_MM_TUERBLATT_DICKE')" :settingsVal="showSettingsContent" :settingsContent="12"  />
                            <radio-container :characteristic="getCharacteristic('KTU_MM_FUNKTION_VSOE')" :settingsVal="showSettingsContent" :settingsContent="13"  />
                            <radio-container :characteristic="getCharacteristic('KTU_MM_PANIK')" :settingsVal="showSettingsContent" :settingsContent="14"  />
                            <radio-container :characteristic="getCharacteristic('KTU_MM_FLUCHT')" :settingsVal="showSettingsContent" :settingsContent="15"  />
                            <radio-container :characteristic="getCharacteristic('CUST_MM_MODELLREIHE')" :settingsVal="showSettingsContent" :settingsContent="16"  />
                            <radio-container :characteristic="getCharacteristic('KTU_MM_MODELL')" :settingsVal="showSettingsContent" :settingsContent="17"  />
                            <radio-container :characteristic="getCharacteristic('KTU_MM_ARTIKELNR')" :settingsVal="showSettingsContent" :settingsContent="18"  />
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-3">
                <div class="column-wrap side-col d-flex flex-column justify-content-end">
                    <div class="side-wrap d-flex flex-column">
                        <div class="info-wrap">
                            <ModelsFound />
                            <div class="inner-wrap d-flex right-part-inner-wrap" data-simplebar>
                                <RModelSelection></RModelSelection>                          
                            </div>
                            <v-app>
                                <div class="d-flex flex-column pa-4">
                                    <v-btn depressed color="green" dark @click="nextStep();">Weiter</v-btn>
                                    <v-row class="px-2">
                                        <v-col cols="6" class="px-2">
                                            <v-btn width="100%" depressed @click="$EventBus.$emit('cancelDialogConfirmation')">Cancel</v-btn> 
                                        </v-col>
                                        <v-col cols="6" class="px-2">
                                            <SaveCurrentConfiguration />   
                                        </v-col>
                                    </v-row>
                                </div>
                            </v-app>
                        </div>
                    </div> 
                </div>
            </div>
        </div>
    </div> -->
</template>

<script>    
    import Vue from 'vue';
    import * as $ from 'jquery';
    import {
        mapActions
    } from 'vuex';
    import {
        mapGetters
    } from 'vuex';
    import {
        DoorConfiguration
    } from '../../configurator/DoorConfiguration';
    import {
        Characteristic,
        ValueDefinition,
        FilterMatrixItem
    } from '../../configurator/types';
    import {
        modelSelectionNavigationItems,
        NavigationFilter,
        modelSelectionNavigationItemsInit
    } from '../../configurator/ModelSelectionNavigationItems';
    import {
        MainNavigationFilter,
        mainNavigationItemsInit
    } from '../../configurator/MainNavigation';
    import {
        FilterMatrix
    } from '../../configurator/FilterMatrix';
    import modelSelectionService from '../../services/Configurator/ModelSelectionService';
    import MSRadioContainer from './components/MSRadionContainer';
    import MSRadioContainerDouble from './components/MSRadioContainerDouble';
    import ModelsFound from './components/ModelsFound.vue';
    import RModelSelection from './components/RModelSelection.vue';
    import SaveCurrentConfiguration from './components/SaveCurrentConfiguration';
    //import productConfiguratorService from '../../services/productConfiguratorService';
    import ResourcesService from '../../services/Configurator/ResourcesService';
    import simplebar from 'simplebar-vue';
    import 'simplebar/dist/simplebar.min.css';
    export default Vue.extend({
        name: 'ModelSelection',
        data() {
            return {
                drawer: true,
                showResources: true,
                toggleResources: false,
                showModal: false,
                showSettingsContent: 1,
                active: 1,
                selectedCharacteristicValues: '',
                filteredCharacteristics: new Array(),
                windowMainNavId: 1,
                //
                currentActiveMenu: 0,
                modelSelectionContext: DoorConfiguration.ModelSelection,
                artikelnrDocument: {},
                bodyCalcHeight: 0,
                nextSaveBtnDisabled: false
            }
        },
        components: {
            simplebar,
            'radio-container': MSRadioContainer,
            'radio-container-double': MSRadioContainerDouble,
            ModelsFound,
            RModelSelection,
            SaveCurrentConfiguration
        },
        computed: {
            ...mapGetters('configuratorModule', ['getCurrentDoorConfiguration', 'getMainNav',
                'getSubNavActiveId'
            ]),
            ...mapGetters('modelSelectionModule', ['getModelSelection', 'getProductMatrixValues',
                'getCharacteristic',
                'getMatrix', 'getNavigationItem', 'getNavigationItems', 'getMatrixCharacteristics'
            ]),
            newConfiguration: function(){
                if(this.$store.state.configuratorModule.productId == 0){
                    return true
                }
                else{
                    return false
                }
            }
        },
        methods: {
            ...mapActions('configuratorModule', ['updateDoorConfiguration', 'setMainNavigationItems',
                'setMainNavActiveId', 'setFilteredCharacteristics', 'incrementMainNavActiveId'
            ]),
            ...mapActions('modelSelectionModule', ['setHasClickedNextStep']),
            toggleModal(state) {
                this.showModal = state;
            },
            settingsNavigation(index) {
                //to be removed
                this.active = index;
                this.showSettingsContent = index;
                if (index == 6) {
                    this.styickyPart();
                }
            },
            getModelSelectionCharacteristics() {
                NProgress.start();
                this.nextSaveBtnDisabled = true
                modelSelectionService.getModelSelectionCharacteristics().then(response => {
                    this.$store.dispatch('modelSelectionModule/setProductMatrix', response.data);
                    NProgress.done();
                    this.nextSaveBtnDisabled = false
                });
            },
            nextStep() {
                this.setHasClickedNextStep(true);
                //to be removed
                let mainNav = new MainNavigationFilter(this.getMainNav);
                let mainNavItems = mainNav.UpdateMainNavigation(this.getNavigationItems, this.windowMainNavId +
                    1);
                this.setMainNavigationItems(mainNavItems);

                const nextMainNavItem = mainNavItems.filter(x => x.itemId == this.windowMainNavId + 1)[0];
                if (nextMainNavItem.disabled === false) {
                    /* this.setMainNavActiveId(this.windowMainNavId + 1); */
                    if (!this.newConfiguration)
                        this.$store.dispatch('configuratorModule/setMainNavActiveId', 0);

					const activeMainNavIndex = this.getMainNav.findIndex(f => f.itemId === this.windowMainNavId)
                    this.incrementMainNavActiveId(activeMainNavIndex);
					this.$EventBus.$emit('triggerMaxHeight')

                    this.$router.push('/product-configurator' + nextMainNavItem.route);
                } else {
                    console.log('ModelSelection step not completed!');
                }
            },
            resetModelSelection() {
                this.doorConfiguration = this.getCurrentDoorConfiguration;
                this.doorConfiguration.ClearAllConfiguration();

                this.$store.dispatch('configuratorModule/updateDoorConfiguration', this.doorConfiguration);
                this.$store.dispatch('modelSelectionModule/resetState');

                const filteredCharacteristicsObject = {
                    selectedCharacteristicValues: '',
                    selectedCharacteristics: new Array(),
                };
                this.$store.dispatch('configuratorModule/setFilteredCharacteristics',
                    filteredCharacteristicsObject);

                this.getModelSelectionCharacteristics();

                //this.resetAdditionalValuesToDefault();

                // this.updateNavigation();
                this.$EventBus.$emit('updateNavigationEmited', 1);

                let objModelSelectionNavigationItemsInit = JSON.parse(JSON.stringify(
                    modelSelectionNavigationItemsInit));
                let objMainNavigationItemsInit = JSON.parse(JSON.stringify(mainNavigationItemsInit));
                let mainNav = new MainNavigationFilter(objMainNavigationItemsInit);
                let mainNavItems = mainNav.UpdateMainNavigation(objModelSelectionNavigationItemsInit, 1, false,
                    true);
                this.setMainNavigationItems(mainNavItems);
            },

            styickyPart() {
                this.$nextTick(function () {
                    var containerHeight = $('.middle-col').height();
                    var bottomPartHeight = containerHeight - $('.v-half.top-part').height();
                    $('.v-half:not(.top-part)').css({
                        'height': bottomPartHeight - 35
                    });
                });
            },
            recalcBodyHeight(){
                //calculation of top-bar height 
                if(this.$refs.topBar.clientHeight != this.bodyCalcHeight)
                    this.bodyCalcHeight = this.$refs.topBar.clientHeight;
            },
            artikelnrDocumentResource(){
                ResourcesService.getResourcesByCharacteristicCode('KTU_MM_ARTIKELNR')
                .then((res) => {
                    this.artikelnrDocument = res.data[0]; 
                });

            }
        },
        created() {
            window.addEventListener("resize", this.recalcBodyHeight);
        },
        destroyed() {
            window.removeEventListener("resize", this.recalcBodyHeight);
        },
        mounted() {
            const modelSelectionValues = this.getCurrentDoorConfiguration.Get(DoorConfiguration.ModelSelection);
            if (modelSelectionValues.length == 0) {
                this.getModelSelectionCharacteristics();
            }
            this.styickyPart();
            this.artikelnrDocumentResource();
            
            //calculation of top-bar height 
            this.bodyCalcHeight = this.$refs.topBar.clientHeight;
            this.$EventBus.$on('disableEnableNextBtn', value => this.nextSaveBtnDisabled = value)
        },
    });
</script>
<style lang="scss" scoped>
    .main-row-fill-height {
        height: 100%;
        margin-left: 0;
        margin-right: 0;

        >.col {
            max-height: 100%;
        }
    }

</style>